import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Header } from '../components/Header';
import { adminService } from '../services/api';
import { useAuth } from '../hooks/useAuth';

export function AdminUserLookup() {
  const { user, loading: authLoading, logout } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = String(searchParams.get('email') || '').trim();

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      navigate('/login');
      return;
    }
    if (user.role !== 'admin') {
      navigate('/');
      return;
    }

    const run = async () => {
      if (!email) {
        navigate('/admin?tab=users');
        return;
      }
      try {
        const res = await adminService.getUserByEmail(email);
        navigate(`/admin/users/${res.data.id}`);
      } catch {
        navigate('/admin?tab=users');
      }
    };

    run();
  }, [authLoading, user, email, navigate]);

  return (
    <>
      <Header user={user} onLogout={logout} />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center text-gray-600">Looking up user...</div>
      </main>
    </>
  );
}
